
    if (!customElements.get("mega-menu")) customElements.define("mega-menu", class megaMenu extends HTMLElement {

        constructor() {
            super();
            this.selectors = {
                toggle: ".js-mega-menu-navbar-toggle",
                navItem: ".js-mega-menu-navbar-item",
                toggleMob: ".js-mega-menu-navbar-toggle-mob",
                navItemMob: ".js-mega-menu-navbar-item-mob",
                desktopMegaMenu: ".js-mega-menu-mobile-desktop",
                buttonSubToggle: ".js-mega-menu-sub-toggle",
                subItem: ".js-mega-menu-column"
            };
            this.menuVisible = false;
            this.mouseOutHideDelay = 50;
            this.mouseOutTimer;

            this.body = document.querySelector('body');
            this.dataParentLink = this.getAttribute('data-parent-link');
            this.navItem = document.querySelector(`${this.selectors.navItem}[data-navlink-handle="${this.dataParentLink}"]`);
            this.navItemMob = document.querySelector(`${this.selectors.navItemMob}[data-navlink-handle="${this.dataParentLink}"]`);
            this.navItems = document.querySelectorAll(`${this.selectors.navItem}`);
            this.desktopMegaMenu = this.querySelector(this.selectors.desktopMegaMenu);
            this.buttonSubToggle = this.querySelectorAll(this.selectors.buttonSubToggle);

            this.subItem = this.querySelectorAll(this.selectors.subItem);



            this.init();
        }

        hideMegaMenu() {
            this.body.classList.remove('is-show-mega-menu');
            this.navItem.classList.remove('is-mega-menu-open');
            this.desktopMegaMenu.classList.remove('is-active');
            this.toggle.setAttribute('aria-expanded', 'false');
            this.menuVisible = false;
        }

        getHeaderHeight() {
            return `${document.querySelector('#section-header').offsetHeight}px`;
        }

        setMegaMenuHeight() {
            const grid = document.querySelector('.mega-menu__grid--abs.is-active');
            if (grid != null) {
                this.desktopMegaMenu.style.height = 'auto';
                const height = `${Math.max(this.desktopMegaMenu.querySelector('.mega-menu__grid--abs.is-active').offsetHeight, this.desktopMegaMenu.querySelector('.mega-menu__block--menu').offsetHeight)}px`;

                this.desktopMegaMenu.style.height = height;
            }
        }

        showMegaMenu() {
            this.body.classList.add('is-show-mega-menu');
            this.menuVisible = true;
            this.setMegaMenuHeight();
        }

        menuOnScroll() {
            window.addEventListener('scroll', (e) => {
                console.log('scroll');
                if(this.menuVisible) {
                    this.setMegaMenuHeight();
                }
            })
        }

        showMegaNavBlock() {
            document.querySelectorAll(`${this.selectors.navItem}`).forEach(el => {
                el.classList.remove('is-mega-menu-open');
            });
            document.querySelectorAll(`${this.selectors.desktopMegaMenu}`).forEach(el => {
                el.classList.remove('is-active');
            });

            document.querySelectorAll(`${this.selectors.desktopMegaMenu}`).forEach(el => {
                el.classList.remove('is-active');
            });
            this.navItem.classList.add('is-mega-menu-open');
            this.desktopMegaMenu.style.top = this.getHeaderHeight();
            this.desktopMegaMenu.classList.add('is-active');
            this.toggle.setAttribute('aria-expanded', 'true');
            this.showMegaMenu();

        }

        initOverlay() {
            const overlay = document.createElement("div");
            overlay.classList.add('mega-menu__overlay')
            this.navItem.append(overlay);
        }

        initMegaMenu() {

            this.navItem.classList.add('has-mega-menu');
            this.navItem.append(this.desktopMegaMenu);
            this.mobMegaMenu = this.desktopMegaMenu.cloneNode(true);
            this.navItemMob.append(this.mobMegaMenu);
            this.navItemMob.classList.add('has-mega-menu');
            this.buttonSubToggleMob = this.navItemMob.querySelectorAll(this.selectors.buttonSubToggle);

            this.subItemMob = this.navItemMob.querySelectorAll(this.selectors.subItem);

        }

        initToggle() {
            this.toggle = this.navItem.querySelector(this.selectors.toggle);
            // this.toggle.setAttribute('href', '#');
            this.toggle.addEventListener('click', (e) => {
                return;
                e.preventDefault();
                if (this.menuVisible) {
                    this.hideMegaMenu();
                } else {
                    this.showMegaNavBlock();
                }
            });


        }

        initNavItem() {
            this.navItem.addEventListener('mouseout', () => {
                this.mouseOutTimer = setTimeout(() => {
                    this.hideMegaMenu();
                }, this.mouseOutHideDelay);
            });
            this.navItem.addEventListener('mouseover', (e) => {
                if (e.target.classList.contains('mega-menu__overlay')) {
                    this.hideMegaMenu();
                } else {
                    this.showMegaNavBlock();
                    clearTimeout(this.mouseOutTimer);
                }
            });

            this.navItem.addEventListener('keydown', (e) => {
//             let lastItem = navItem.find('.mega-menu__block--menu .mega-menu__linklist-item:last-child').find('.is-active').find('button, [href]').last()[0];
//             if (lastItem == undefined) {
//                 lastItem = navItem.find('.mega-menu__linklist-item:last-child>button,.mega-menu__linklist-item:last-child>button>[href]').last()[0];
//             }
//             if ((e.key == 'Tab' && !e.shiftKey && e.target == lastItem) || e.key == 'Escape') {
//                 hideMegaMenu();
//                 if (menu.length > 0) {
//                     navToggleButton.attr('aria-expanded', 'false');
//                 }
//             }
//             if (e.key == 'Escape') {
//                 if (menu.length > 0) {
//                     navToggleButton.focus();
//                 }
//             }
            });
        }

        subToggleEventMob(el, e) {
            e.preventDefault();
            let isActive = el.classList.contains('is-active');
            this.subItemMob.forEach(item => {
                item.classList.remove('is-active');
            })

            this.buttonSubToggleMob.forEach(item => {
                item.classList.remove('is-active');
                item.setAttribute('aria-expanded', false);
            });

            if (!isActive) {
                el.classList.add('is-active');
                el.setAttribute('aria-expanded', true);
                const elementMob = this.mobMegaMenu.querySelector(`.js-mega-menu-column[data-value="${el.getAttribute('data-value')}"]`);

                if (elementMob != null) {
                    elementMob.classList.add('is-active');
                }
            }

        }

        subToggleEvent(el, e) {
            // e.preventDefault();
            this.subItem.forEach(item => {
                item.classList.remove('is-active');
            })


            this.buttonSubToggle.forEach(item => {
                item.classList.remove('is-active');
                item.setAttribute('aria-expanded', false);
            });

            el.classList.add('is-active');
            el.setAttribute('aria-expanded', true);
            const element = this.desktopMegaMenu.querySelector(`.js-mega-menu-column[data-value="${el.getAttribute('data-value')}"]`);
            if (element != null) {
                element.classList.add('is-active');
            }

            this.setMegaMenuHeight();

        }

        init() {
            if (this.navItem != null) {
                this.initMegaMenu();
                this.initOverlay();
                this.initToggle();
                this.initNavItem();
                this.buttonSubToggle.forEach(el => {
                    el.addEventListener('click', e => {
                        this.subToggleEvent(el, e);
                    })
                    el.addEventListener('mouseover', e => {
                        this.subToggleEvent(el, e);
                    })
                });
                this.subItemMob.forEach(item => {
                    item.classList.remove('is-active');
                })

                this.buttonSubToggleMob.forEach(item => {
                    item.classList.remove('is-active');
                    item.setAttribute('aria-expanded', false);
                });
                this.buttonSubToggleMob.forEach(el => {
                    el.addEventListener('click', e => {
                        this.subToggleEventMob(el, e);
                    })
                })
                this.menuOnScroll();

            }

        }
    });
